import React from 'react';
import { useTranslation } from 'react-i18next';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useScopeOfWork, useCompanies } from '../../../hooks';
import AddIcon from '@mui/icons-material/Add';

const ScopeOfWorkPage = () => {
  const { t } = useTranslation();

  return (
    <DynamicCrudPage
      entityType="scopeOfWork"
      hook={useScopeOfWork}
      additionalHooks={{
        companies: useCompanies,
      }}
      addButtonTextKey="table.actions.addScopeOfWork"
      addButtonIcon={<AddIcon />}
      entityTypeForDataTable="scopeOfWork"
    />
  );
};

export default ScopeOfWorkPage; 